import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-toggle-password',
  templateUrl: './toggle-password.component.html',
  styleUrls: ['./toggle-password.component.scss']
})
export class TogglePasswordComponent {
  @Output() toggleEvent = new EventEmitter<string>();

  @Input() hidePassword: string;

  togglePassword() {
    this.toggleEvent.emit(this.hidePassword);
  }
}
